import GitHub from 'github-api';
import { LabelMap } from './LabelMap';

export const getSorting = (sort) => {
    const { order, orderBy, secondaryOrder, secondaryOrderBy, assignmentSort } = sort;
    if (assignmentSort === 'ticketLength') {
        return (a, b) => {
            return a.tickets.length - b.tickets.length;
        }
    } else if (order === 'desc' && secondaryOrder === 'desc') {
        return (a, b) => {
            return b[orderBy].sort - a[orderBy].sort || b[secondaryOrderBy].sort - a[secondaryOrderBy].sort;
        }
    } else if (order === 'desc' && secondaryOrder === 'asc') {
        return (a, b) => {
            return b[orderBy].sort - a[orderBy].sort || a[secondaryOrderBy].sort - b[secondaryOrderBy].sort;
        }

    } else if (order === 'asc' && secondaryOrder === 'desc') {
        return (a, b) => {
            return a[orderBy].sort - b[orderBy].sort || b[secondaryOrderBy].sort - a[secondaryOrderBy].sort;
        }

    } else if (order === 'asc' && secondaryOrder === 'asc') {
        return (a, b) => {
            return a[orderBy].sort - b[orderBy].sort || a[secondaryOrderBy].sort - b[secondaryOrderBy].sort;
        }

    }
}

export const getStatusFiltering = (filter) => {
    switch (filter.status) {
        case 'OPEN':
            return (x) => x.status.sort === 2;
        case 'BLOCKED':
            return (x) => x.status.sort === 1;
        case 'CLOSED':
            return (x) => x.status.sort === 0;
        case 'ANY':
            return (x) => true;
        default:
            return () => false;
    }
}

export const getAssignmentFiltering = (filter) => {
    switch (filter.assignment) {
        case 'NONE':
            return (x) => x.assignment.sort === 0;
        case 'ANY':
            return (x) => true;
        case 'ALL':
            return (x) => x.assignment.sort > 0;
        case 'ME':
            return (x) => x.assignment.sort > 100;
        default:
            return (x) => false;
    }
}

export const getReleaseFiltering = (filter) => {
    switch (filter.release) {
        case 'NONE':
            return (x) => x.release.sort === 0;
        case 'ANY':
            return (x) => true;
        case 'ALL':
            return (x) => x.release.sort > 0;
        case 'CURRENT':
            return (x) => x.release.sort.toString() === x.release.current.toString();
        case 'PAST3':
            return (x) => (x.release.sort >= x.release.past3 && x.release.sort <= x.release.current);
        default:
            return (x) => false;
    }
}

export const getSeverityFiltering = (filter) => {
    switch (filter.severity) {
        case 'NONE':
            return (x) => x.severity.sort === 0;
        case 'ANY':
            return (x) => true;
        case 'ALL':
            return (x) => x.severity.sort > 1;
        case 'SEV0':
            return (x) => x.severity.sort === 6;
        case 'SEV1':
            return (x) => x.severity.sort === 5;
        case 'SEV2':
            return (x) => x.severity.sort === 4;
        case 'SEV3':
            return (x) => x.severity.sort === 3;
        case 'SEV4':
            return (x) => x.severity.sort === 2;
        default:
            return (x) => false;
    }
}

export const getReleaseDateNumber = (weekday, offset) => {
    offset = (offset) ? offset : 0;
    var weekdays = ["Sun", "Mon", "Tue", "Wed", "Thurs", "Fri", "Sat"];
    var date = new Date();
    var index = weekdays.indexOf(weekday);
    var difference = index - date.getUTCDay();
    if (difference < 0) {
        difference = 7 + difference;
    }
    date.setUTCDate(date.getUTCDate() + difference + offset);
    let substring = date.toISOString().substring(0, 10).replace(/-/g, '');
    let int = parseInt(substring, 10);
    return int;
}


// --- API ---
export const getTickets = (params) => {
    const { filter, user, repo } = params;
    const gh = new GitHub({
        token: localStorage.getItem('db-oauth')
    });

    const usernamePromise = () => {
        // return new Promise((resolve, reject) => {
        //     return gh.getUser().getProfile((error, response) => {
        //         if (response && response.login) {
        //             const username = response.login
        //             resolve(username)
        //         } else {
        //             localStorage.removeItem('db-oauth');
        //             const authError = (error) ? error : new Error();
        //             authError.message = 'UNAUTHORIZED';
        //             reject(authError);
        //         }
        //     })
        // })
        return new Promise((resolve) => resolve("bob"))
    }

    const ticketsPromise = () => {
        return new Promise((resolve, reject) => {
            return gh.getIssues(user, repo).listIssues(filter, (error, response) => {
                console.log('<> resp <> resp <> resp <> resp <>');
                console.log(response);
                resolve(response);
                if (error) {
                    localStorage.removeItem('db-oauth');
                    const authError = (error) ? error : new Error();
                    authError.message = 'UNAUTHORIZED';
                    reject(authError);
                }
            })
        });
    }

    return Promise
        .all([usernamePromise(), ticketsPromise()])
        .then((response) => {
            const test = processTickets(response);
            return test
        })
}




export const getAssignments = (params) => {
    const { user, repo, userList } = params; // TODO: filters!!!
    const gh = new GitHub({
        token: localStorage.getItem('db-oauth')
    });

    let promises = [];
    for (let i = 0; i < userList.length; i++) {


        const assignmentTickets = () => {
            return new Promise((resolve, reject) => {
                return gh.getIssues(user, repo).listIssues({
                    assignee: userList[i],
                    state: 'open',
                    // labels: 'customer'
                }, (error, response) => {

                    if (error) {
                        console.log('ERROR:::');
                        console.log(error)
                        localStorage.removeItem('db-oauth');
                        reject(error);
                    }
                    if (response) {
                        const assignments = convertGitResponseAssignments(userList[i], response);
                        resolve(assignments);
                    }
                })
            })
        }
        promises.push(assignmentTickets());
    }
    return Promise.all(promises)
}

export const convertGitResponseAssignments = (user, response) => {

    let tickets = response.map((ticket) => {

        // id
        const id = ticket.number;

        const url = ticket.url.replace('api.', '').replace('/repos', '');

        // customer defect
        const customerDefect = ticket.labels.filter((label) => {
            return label.name.toLowerCase() === 'customer' || label.name.toLowerCase() === 'defect';
        })

        // quick-win
        const quickWin = ticket.labels.filter((label) => {
            return label.name.toLowerCase() === 'quick-win';
        })

        const release = ticket.labels.filter((label) => {
            return label.name.toLowerCase().includes('release_');
        })

        const featureRequest = ticket.labels.filter((label) => {
            return label.name.toLowerCase().includes('s-feature request');
        })

        const blocked = ticket.labels.filter((label) => {
            return label.name.toLowerCase().includes('s-blocked');
        })

        let status = [];
        if (release.length > 0) {
            status.push('R');
        }
        if (blocked.length > 0) {
            status.push('B');
        }
        if (!(status.length > 0)) {
            status.push('-');
        }

        let type = [];
        if (customerDefect.length > 0) {
            type.push('CD');
        }
        if (featureRequest.length > 0) {
            type.push('FR');
        }
        if (quickWin.length > 0) {
            type.push('QW')
        }

        if (!(type.length > 0)) {
            type.push('?')
        }

        return {
            id,
            url,
            status,
            type,
        }

    })

    return {
        id: user,
        tickets,
        rows: Math.ceil(tickets.length / 3) + 1
    }
}


export const parseParams = (location) => {
    let path = location.pathname;
    let search = location.search;
    path = (path) ? path : '';
    let filter = {};
    search
        .substring(1, search.length)
        .split('&')
        .map((query) => {
            const split = query.split('=');
            const key = split[0];
            const value = split[1];
            return filter[key] = value;
        });

    filter = {
        status: (filter.status) ? filter.status : 'ANY',
        release: (filter.release) ? filter.release : 'ANY',
        severity: (filter.severity) ? filter.severity : 'ANY',
        assignment: (filter.assignment) ? filter.assignment : 'ANY',
        updated: (filter.updated) ? filter.updated : '30'
    }

    if(path.includes('rollbar') || path.includes('quickwin')) {
        filter.updated = '365'
    }

    return {
        filter,
    }
}

export const createUrlParams = (filters) => {
    let url = '?';
    let i = 0;
    for (let filter in filters) {
        if (i !== 0) {
            url += '&';
        }
        let filterString = `${filter}=${filters[filter]}`;
        url += filterString;
        i++;
    }

    return url;
}

export const getPastDate = (dayCountStr) => {
    const dayCount = parseInt(dayCountStr, 10);
    const date = new Date();
    date.setDate(date.getDate() - dayCount);
    const ISOString = date.toISOString();
    return ISOString;
}



export const processTickets = (response) => {
    const username = response[0];
    const tickets = response[1];

    const blockedLabelKey = LabelMap('blocked');
    const severityLabelKey = LabelMap('severity');
    const releaseLabelKey = LabelMap('release');

    const processedTickets = tickets.map(ticket => {

        let labelMap = ticket.labels.reduce((map, obj) => {
            map[obj.name] = true;
            return map;
        }, {});
        labelMap = (labelMap) ? labelMap : {};
        const labelArray = Object.keys(labelMap)

        // id
        const id = ticket.number;

        // url
        const urlString = ticket.url.replace('api.', '').replace('/repos', '');
        const url = {
            string: urlString
        }

        // status
        let statusString = ticket.state;
        let statusSort = (statusString === "open") ? 2 : 0;
        if (statusSort === 2) {
            const blocked = labelMap.hasOwnProperty(blockedLabelKey);
            if (blocked) {
                statusString = 'blocked';
                statusSort = 1;
            }
        }

        const status = {
            string: statusString,
            sort: statusSort
        }

        // number
        const number = {
            sort: ticket.number,
            string: ticket.number,
        }
        // title
        const title = {
            string: ticket.title,
        }
        // summary
        const summary = {
            string: ticket.body
        }
        // assignment
        let assignmentSort, assignmentStore;
        if (!(ticket.assignees.length > 0)) {
            assignmentStore = { NA: true };
            assignmentSort = 0;

        } else {
            assignmentSort = ticket.assignees.length;
            assignmentStore = ticket.assignees.reduce((map, obj) => {
                map[obj.login] = true;
                return map
            }, {});
            if(assignmentStore.hasOwnProperty(username)) {
                assignmentSort += 100;
            }
        }

        const assignment = {
            sort: assignmentSort,
            store: assignmentStore,
            string: 'NA'
        }

        // created
        const createdDate = new Date(ticket.created_at);
        const createdSort = createdDate.getTime();
        const createdString = createdDate.toLocaleDateString();

        const created = {
            string: createdString,
            sort: createdSort
        }

        // updated
        let updatedSinceStr;
        const updatedDate = new Date(ticket.updated_at);
        const now = new Date();
        const diffTime = now.getTime() - updatedDate.getTime();
        const diffMinutes = diffTime / 1000 / 60
        const diffHours = diffMinutes / 60;
        const diffDays = diffHours / 24;

        if(diffDays >= 1) {
            updatedSinceStr = `${diffDays.toFixed(1)} days`
        } else if(diffHours >= 1) {
            updatedSinceStr = `${diffHours.toFixed(1)} hours`
        } else {
            updatedSinceStr = `${Math.floor(diffMinutes)} minutes`
        }

        const updatedSort = updatedDate.getTime();
        // const updatedString = updatedDate.toLocaleString().replace(', ', '\n');
        const updatedString = updatedSinceStr;

        const updated = {
            string: updatedString,
            sort: updatedSort
        }

        // release
        let releaseNumber, releaseString;
        let releaseSort = 0;
        let releaseStrings = [];
        for (let i = 0; i < labelArray.length; i++) {
            const label = labelArray[i];
            if (label.includes(releaseLabelKey)) {

                releaseString = label.split('_')[1];
                releaseNumber = parseInt(releaseString, 10);
                if (releaseSort < releaseNumber) {
                    releaseSort = releaseNumber;
                }

                releaseStrings.push(releaseString);
            }
        }
        if (releaseSort === 0) {
            releaseStrings = ['NA'];
        }

        const past3Str = getReleaseDateNumber('Thurs', -14).toString();

        var currentReleaseStr = getReleaseDateNumber('Thurs').toString();

        const release = {
            list: releaseStrings,
            sort: releaseSort,
            current: currentReleaseStr,
            string: 'NA',
            past3: past3Str
        }

        // severity
        let severityLabel, severitySort;
        for (let i = 0; i < labelArray.length; i++) {
            const label = labelArray[i];
            if (label.includes(severityLabelKey)) {
                severityLabel = label;
                break;
            }
        }
        if (severityLabel) {
            let severityLabelNumber = parseInt(severityLabel.substring(severityLabelKey.length, severityLabelKey.length + 1), 10);
            severitySort = 6 - severityLabelNumber;
        } else {
            if(labelMap.hasOwnProperty('Minor')) {
                severityLabel = 'Minor';
                severitySort = 1;
            } else {
                severityLabel = 'NA';
                severitySort = 0;
            }
        }

        const severity = {
            string: severityLabel,
            sort: severitySort
        }

        return {
            id, // int
            url, // string
            status, // o
            number, // int
            title, // string
            summary, // string
            severity, // obj
            assignment, // obj
            created, // obj
            updated, // obj
            release, // obj
            labelMap,
        }

    })
    return {
        username,
        tickets: processedTickets
    }


}


// WEBPACK FOOTER //
// ./src/js/others/DataHelpers.js